/**
* Тип документа пользователя(паспорт, ИНН и пр.)
*/
export class DocumentTypeData {
  /**
  * Идентификатор документа
  */
  public Id: number = 0;

  /**
  * Внутренний код документа
  */
  public Code: number = 0;

  /**
  * Наименование документа
  */
  public DisplayName: string = "";

  /**
  * Маска документа
  */
  public Mask: string = "";

  /**
  * Название категории (коммунальные услуги, штрафы и т.д.)
  */
  public Category: string = "";

  /**
  * Конструктор с загрузкой данных из JObject.
  */
  public constructor(src: any = null) {
    if (src == null)
      return;

    this.Id = src.Id ?? 0;
    this.Code = src.Code ?? 0;
    this.DisplayName = src.DisplayName ?? "";
    this.Mask = src.Mask ?? "";
    this.Category = src.Category ?? "";
  }

  public copy(data: DocumentTypeData) {
    this.Id = data.Id;
    this.Code = data.Code;
    this.DisplayName = data.DisplayName;
    this.Mask = data.Mask;
    this.Category = data.Category;
  }
}

